import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { ammControlloFormValidators } from '../../validators/amm-controllo-common.form-validators';
import { CkNormeValuesEnum } from '../../common/consts/ckNormeValues.enum';
import { normeSpaDualisticoAssembleaRules } from './norme-spa-dualistico-assemblea.rules';
import { normeSpaDualisticoConsiglioMembriRules } from './norme-spa-dualistico-consigli-membri.rules';

export const NormeSpaDualisticoRules: FormGroupRules = {
    ...normeSpaDualisticoAssembleaRules,
    ...normeSpaDualisticoConsiglioMembriRules,
};

export const NormeSpaDualisticoFormValidators = [...Object.values(NormeSpaDualisticoRules), ...ammControlloFormValidators(CkNormeValuesEnum.normeSpaDualistico)];
